import React, { Fragment } from 'react';
import { number, func, instanceOf } from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';

import { setSurveyInfo } from '../../../actions/turnkeyOmnibusActions';

const setDropdownData = data => {
  if (data) {
    return data.map(item => ({ ...item, value: item.id, label: item.name }));
  }
  return [];
};

const getCategory = (array, key) => {
  if (key && array.length > 0) {
    return array.find(item => item.value === key);
  }
  return null;
};

const CategorySelection = ({ setSurveyInfo, ieCategories, categoryId, surveyId }) => {
  const state = {
    category: getCategory(ieCategories, categoryId),
  };

  const handleOnChange = val => {
    const defaultValue = { id: null, name: '', surveyGizmoId: null };
    const categoyInfo = val ? getCategory(ieCategories, val) : defaultValue;
    const { id = null, name = '' } = categoyInfo;
    setSurveyInfo({
      categoryId: id,
      categoryName: name,
    });
  };

  return (
    <Fragment>
      <div className="ie--settings--form">
        <Select
          options={ieCategories}
          className="ie--autoselect"
          onChange={handleOnChange}
          value={state.category}
          placeholder="Select for Category"
          id="category-select"
          onBlurResetsInput={false}
          onSelectResetsInput={false}
          autoFocus
          simpleValue
          name="category-select"
          searchable
          disabled={surveyId && categoryId}
          arrowRenderer={() => (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              id="magnify"
            >
              <path d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5-1.5 1.5-5-5v-.79l-.27-.27A6.516 6.516 0 0 1 9.5 16a6.5 6.5 0 1 1 0-13m0 2C7 5 5 7 5 9.5S7 14 9.5 14 14 12 14 9.5 12 5 9.5 5z" />
            </svg>
          )}
        />
      </div>
      <div className="ie--settings--message">
        Please select a category relevant to the topic(s) of your questionnaire. Study and Category will be locked after it’s selected. <br/>
        If you are interested in a category that does not appear in this list, please contact your MRI-Simmons Account Director.
      </div>
    </Fragment>
  );
};

CategorySelection.propTypes = {
  ieCategories: instanceOf(Array),
  setSurveyInfo: func.isRequired,
  categoryId: number,
  surveyId: number,
};

CategorySelection.defaultProps = {
  categoryId: null,
  surveyId: null,
  ieCategories: [],
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { ieCategories, surveyInfo } = turnkeyOmnibus;
  return {
    ieCategories: setDropdownData(ieCategories.data),
    categoryId: surveyInfo.categoryId,
    surveyId: surveyInfo.surveyId,
  };
};

export default connect(
  mapStateToProps,
  { setSurveyInfo }
)(CategorySelection);
